// src/graphql/mutations/changeSystemState.js
import { gql } from '@apollo/client';

export const CHANGE_SYSTEM_STATE = gql`
  mutation setSystemState($system_id: String!, $state: SystemState!) {
    changeSystemState(system_id: $system_id, system_state: $state) {
      result
    }
  }
`;

